import React from "react";
import "../Menu.css";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Ramakanth = () => {
  return (
    <>
      <Navbar />
      <Homecarousel />

      <div className="container">
        <center>
          <div>
            <h2 className="heading-p1">Ramakanth Boorla</h2>
          </div>
          <div>
            <h6 className="heading-p2">
              Expert on Organic and Natural Farming Certification Schemes
            </h6>
          </div>
          <div>
            <img className="image" src="../images/ramakanth.jpg" alt="" />
          </div>
        </center>
      </div>
      <div className="row">
        <div className="col containerin">
          <b>Present</b>
          <br />
          <span>
            External Expert on Organic Certification schemes like NPOP 2024,
            USDA NOP, PGS and Natural Farming.
          </span>
          <br />
          <br />
          <b>Past</b>
          <ul className="ulstyle">
            <li>
              <b>Velugu - SERP 1999 - 2007</b>
              <br />
              District resource person and CIF Appraiser Establishing bulk milk
              cooling units, appraiser for rural livelihoods.
            </li>
            <li>
              <b>APMAS 2007 - 2011</b>
              <br />
              Livelihood affiliate Resource person for district livelihood
              resource center Adilabad and trainer for watershed activities.
            </li>
            <li>
              <b>Ekalavya Foundation 2014 – 2020</b>
              <br />
              Organic Farming project head and Project manager for Sendriya
              Mitra. Project manager for Sendriya Mitra (organic agriculture
              extension project) and taught organic agriculture diploma students
              in Ekalavya organic diploma college.
            </li>
            <li>
              <b>RK Consultancy Services 2020 – till date</b>
              <br />
              Agriculture consultant and trainer (Specialist in Organic
              farming). Consultancy for farm planning, Agro-forestry, Natural
              Resource Management (NRM) and Execution, trainer in organic
              farming.
            </li>
          </ul>
          <div style={{ marginBottom: "10px" }}>
            <b>Education :</b>{" "}
            <ul className="ulstyle">
              <li>
                DBA in Rural Development, National Institute of management
                (distance).
              </li>
              <li>MPC, Government degree college (Adilabad).</li>
              <li>SSC, Sri Gopala Krishna Vidya Mandir (Adilabad).</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Ramakanth;
